import { OnlineContactDetails, } from "./OnlineContactDetails";
import { QRWaiterContactDetails, } from "./QRWaiterContactDetails";
export const ContactDetails = {
    empty(params) {
        return params.isQrWaiterOrder
            ? QRWaiterContactDetails.empty(params.contactDetailsLock)
            : OnlineContactDetails.empty(params.validatePhoneService, params.contactDetailsLock);
    },
    fromStorageData({ validatePhoneService, contactDetailsLock, storageData, }) {
        switch (storageData.type) {
            case "Online":
                return OnlineContactDetails.fromStorageData({
                    validatePhoneService,
                    contactDetailsLock,
                    storageData,
                });
            case "QRWaiter":
                return QRWaiterContactDetails.fromStorageData(contactDetailsLock, storageData);
        }
    },
};
